import React, {useEffect, useState, useCallback} from "react";
import axios from "axios";
import { Box, Table, Button } from "@allxsmith/bestax-bulma";
import Nav from "../Nav/Nav";
import LoadingSpinner from "../Utils/Spinner";

export default function VanPartsExpenses() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");

    const load = useCallback(() => {
        setLoading(true);
        const qs = [];
        if (start) qs.push("start=" + start);
        if (end) qs.push("end=" + end);
        axios.get("/api/vanparts-expenses" + (qs.length ? "?" + qs.join("&") : ""))
            .then(r => setData(r.data))
            .catch(() => setData({error: true}))
            .finally(() => setLoading(false));
    }, [start, end]);

    useEffect(() => { load(); }, [load]);

    document.title = "Van Parts Expenses";
    const fmtDate = d => d ? new Date(d).toLocaleDateString("en-GB") : "";
    const money = n => "£" + Number(n || 0).toFixed(2);

    return (
        <div>
            <Nav/>
            <br/><br/>
            <Box>
                <h1 className="title">Van Parts Direct - expenses</h1>
                <p className="has-text-grey" style={{marginBottom: "14px"}}>Money-out lines for Van Parts Direct only. Read-only.</p>
                <div className="field is-grouped" style={{marginBottom: "14px", alignItems: "flex-end"}}>
                    <div className="control">
                        <label className="label is-small">From</label>
                        <input className="input is-small" type="date" value={start} onChange={e => setStart(e.target.value)}/>
                    </div>
                    <div className="control">
                        <label className="label is-small">To</label>
                        <input className="input is-small" type="date" value={end} onChange={e => setEnd(e.target.value)}/>
                    </div>
                    <div className="control">
                        <Button color={"primary"} onClick={load}>Apply</Button>
                    </div>
                </div>
                {loading ? <LoadingSpinner/> : null}
                {!loading && data && !data.error ?
                    <div>
                        <p style={{marginBottom: "10px"}}><strong>{data.count}</strong> expense(s) &middot; total <strong>{money(data.total)}</strong></p>
                        <Table>
                            <thead>
                                <tr><th>Date</th><th>Description</th><th>Supplier</th><th>Invoice</th><th style={{textAlign: "right"}}>Amount</th></tr>
                            </thead>
                            <tbody>
                                {(data.expenses || []).map(x =>
                                    <tr key={x.id}>
                                        <td>{fmtDate(x.date)}</td>
                                        <td>{x.description}</td>
                                        <td>{x.contact}</td>
                                        <td>{x.invoice_number}</td>
                                        <td style={{textAlign: "right"}}>{money(x.amount)}</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div> : null}
                {!loading && data && data.error ? <p className="has-text-danger">Could not load expenses.</p> : null}
            </Box>
        </div>
    );
}
